var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCounsel3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1560",
    "data-name": "Group 1560",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 158.807,
    height: 158.807,
    viewBox: "0 0 158.807 158.807",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1851",
    "data-name": "Path 1851",
    d: "M79.4,0A79.4,79.4,0,1,1,0,79.4,79.4,79.4,0,0,1,79.4,0Z",
    fill: "#fff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1840",
    "data-name": "Path 1840",
    d: "M79.4,0A79.4,79.4,0,1,1,0,79.4,79.4,79.4,0,0,1,79.4,0Z",
    transform: "translate(0)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_90",
    "data-name": "Mask Group 90",
    transform: "translate(0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_13",
    "data-name": 13,
    transform: "translate(37.728 23.69)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1524",
    "data-name": "Group 1524",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1523",
    "data-name": "Group 1523"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1841",
    "data-name": "Path 1841",
    d: "M37.66,369.779v73.938c0,4.77,3.317,8.671,7.371,8.671H88.067c4.056,0,7.373-3.9,7.373-8.671V369.779c0-4.769-3.317-8.671-7.373-8.671H45.031C40.977,361.108,37.66,365.009,37.66,369.779Z",
    transform: "translate(-37.66 -361.108)",
    fill: "#6f7272"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1842",
    "data-name": "Path 1842",
    d: "M85.366,365.617H41.475V441.36l43.892-56.2Z",
    transform: "translate(-34.53 -357.409)",
    fill: "#20b7ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1843",
    "data-name": "Path 1843",
    d: "M85.366,433.111V376.353l-43.892,56.2v.558Z",
    transform: "translate(-34.53 -348.601)",
    fill: "#33c9f2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1844",
    "data-name": "Path 1844",
    d: "M54.81,361.935a2.84,2.84,0,1,1-2.84,2.84A2.841,2.841,0,0,1,54.81,361.935Z",
    transform: "translate(-25.92 -360.43)",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1845",
    "data-name": "Path 1845",
    d: "M54.724,407.689a2.648,2.648,0,1,1-2.649,2.647A2.646,2.646,0,0,1,54.724,407.689Z",
    transform: "translate(-25.834 -322.892)",
    fill: "#939598"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1525",
    "data-name": "Group 1525",
    transform: "translate(16.655 51.087)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1846",
    "data-name": "Path 1846",
    d: "M71.883,399.425a12.651,12.651,0,1,0-10.021,14.82A12.663,12.663,0,0,0,71.883,399.425ZM61.507,412.416a10.786,10.786,0,1,1,8.545-12.637A10.8,10.8,0,0,1,61.507,412.416Z",
    transform: "translate(-46.809 -389.171)",
    fill: "#ce1b31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1847",
    "data-name": "Path 1847",
    d: "M56.007,391.55a8.608,8.608,0,1,0,10.083,6.821A8.619,8.619,0,0,0,56.007,391.55Zm2.911,15.071a6.742,6.742,0,1,1,5.341-7.9A6.75,6.75,0,0,1,58.918,406.621Z",
    transform: "translate(-44.986 -387.348)",
    fill: "#ce1b31"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1526",
    "data-name": "Group 1526",
    transform: "translate(39.987 65.291) rotate(-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1848",
    "data-name": "Path 1848",
    d: "M67.414,32.458c-.049.215-.586.592-.734.741l-1.424,1.425c-1.44,1.447-.692,1.793-2.13,3.235-2.985,2.989-6.426,5.492-9.33,8.549-2.641,2.783-5.7,1.962-9.339,1.3-5.953-1.089-13.287-.546-18.466-3.985a45.136,45.136,0,0,1-6.262-4.44c-1.48-1.418-2.6-3.031-4.329-4.252-1.635-1.154-5.583-2.61-2.838-4.593A7.484,7.484,0,0,1,15.376,29.1,8.642,8.642,0,0,1,20.435,30.6c1.092.712,1.744,1.839,2.823,2.532A17.74,17.74,0,0,0,28,34.948a71.012,71.012,0,0,0-8.1-8.638l-7.227-7.194Q7.53,13.99,2.383,8.867L2.321,8.8c-.65-.65-1.4-1.278-1.99-1.986a1.609,1.609,0,0,1-.324-.978,1.915,1.915,0,0,1,0-.289c0-.013,0-.027,0-.038a5.875,5.875,0,0,1,.076-.641A4.474,4.474,0,0,1,3.689,1.188,4.513,4.513,0,0,1,4.3,1.1l.038,0a2.6,2.6,0,0,1,.746.044,1.632,1.632,0,0,1,.763.4c.38.357.73.728,1.1,1.1,2.347,2.341,4.673,4.7,7.012,7.047,1.595,1.6,3.137,3.308,4.815,4.821,1.505,1.358,3.9,3.559,4.961,3.681-.4-.339-.677-1.147-1.118-1.58-.468-.459-.939-.914-1.405-1.376a11.466,11.466,0,0,1-2.594-2.847c-.826-1.922,1.165-4.467,3.04-4.839,1.97-.39,3.686,1.362,5.074,2.458.408.322,2.2,1.293,1.884.508-.608-1.509-2.441-3.726-2.558-4.8a3.869,3.869,0,0,1,3.411-3.967c2.742-.433,5.17,2.66,6.85,4.378.071-.6-1.16-1.868-1.183-2.525A3.81,3.81,0,0,1,36.412.893c2.987-2.636,5.794,1.229,7.955,3A73.074,73.074,0,0,1,54.959,14.59a46.945,46.945,0,0,1,4.364,5.967c1.047,1.851,1.076,4.158,2.312,5.925a33.344,33.344,0,0,0,3.908,3.965c.661.657,1.2,1.2,1.427,1.427C67.168,32.072,67.463,32.243,67.414,32.458Z",
    transform: "translate(0 0)",
    fill: "#eab38b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1849",
    "data-name": "Path 1849",
    d: "M20,0,0,21.184l6.677,5.129,19.664-20.9Z",
    transform: "translate(46.02 28.565)",
    fill: "#f9b316"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1850",
    "data-name": "Path 1850",
    d: "M6.719,6.288C5.7,7.664,3.466,7.544,1.76,6.027L.34,4.753A4.227,4.227,0,0,1,0,4.418c.016-.213.038-.439.075-.641A4.476,4.476,0,0,1,3.683.095,4.516,4.516,0,0,1,4.294,0l.038,0L5.467,1.018C7.171,2.541,7.73,4.913,6.719,6.288Z",
    transform: "translate(0.585 0.852)",
    fill: "#f2c4a5"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCounsel3);
export default __webpack_public_path__ + "static/media/counsel3.66416a04e30b24803d6e87187ebf2f62.svg";
export { ForwardRef as ReactComponent };